<template>
  <div :class="['box-sidebar']">
    <el-menu
      :collapse="leftMenuStatus1"
      :background-color="cssParam1.bgLeftMenu"
      :text-color="cssParam1.leftMenuColor"
      :unique-opened="false"
      :active-text-color="cssParam1.leftMenuActiveColor"
      :collapse-transition="true"
      :default-active="routeMenuIndex"
      :default-openeds="['admin_filldata','admin_system','admin_tijian']"
      mode="vertical"
    >
      <el-menu-item index="admin_index" @click.native="clkItem('/admin/index')">
        <i class="menuitem-icon iconfont icon-dashboard"></i>
        <span class="menuitem-text" slot="title">控制台 <span class="hid-hotkey">[Alt+H]</span></span>
      </el-menu-item>
      <el-submenu index="admin_tijian" v-if="false">
        <template slot="title">
          <i class="menuitem-icon iconfont  icon-checklist"></i>
          <span>体检管理</span>
        </template>
          <el-menu-item index="admin_tijian_list" @click.native="clkItem('/admin/tijian/list')">
            <i class="menuitem-icon iconfont icon-checklist"></i>
            <span class="menuitem-text" slot="title">体检记录综合统计</span>
          </el-menu-item>

          <el-menu-item index="admin_company_company-count-list" @click.native="clkItem('/admin/company/company-count-list')">
            <i class="menuitem-icon iconfont icon-checklist"></i>
            <span class="menuitem-text" slot="title">单位统计信息</span>
          </el-menu-item>
      </el-submenu>
<!--v-if="isSystemManager"-->
      <el-submenu index="admin_system" >
        <template slot="title">
          <i class="menuitem-icon iconfont icon-settings"></i>
          <span>系统管理</span>
        </template>

        <el-menu-item index="admin_system_user-manage"
          @click.native="clkItem('/admin/system/user-manage')">
          <i class="menuitem-icon iconfont icon-users"></i>
          <span class="menuitem-text" slot="title">监管人员维护</span>
        </el-menu-item>

        <el-menu-item index="admin_company_company-list"
                      @click.native="clkItem('/admin/company/company-list')">
          <i class="menuitem-icon iconfont icon-users"></i>
          <span class="menuitem-text" slot="title">体检单位管理</span>
        </el-menu-item>




        <el-menu-item index="admin_tijian_company_tijian-company-list"
                      @click.native="clkItem('/admin/tijian_company/tijian-company-list')">
          <i class="menuitem-icon iconfont icon-users"></i>
          <span class="menuitem-text" slot="title">体检中心管理</span>
        </el-menu-item>

        <el-menu-item index="admin_system_common-tijian-project-list" @click.native="clkItem('/admin/system/common-tijian-project-list')">
          <i class="menuitem-icon iconfont icon-fenlei"></i>
          <span class="menuitem-text" slot="title">通用体检项目管理</span>
        </el-menu-item>

        <el-menu-item index="admin_system_industry-list" @click.native="clkItem('/admin/system/industry-list')">
          <i class="menuitem-icon iconfont icon-industry_certification"></i>
          <span class="menuitem-text" slot="title">行业信息</span>
        </el-menu-item>


        <el-menu-item index="admin_system_tijian-project-type-list" @click.native="clkItem('/admin/system/tijian-project-type-list')">
          <i class="menuitem-icon iconfont icon-fenlei"></i>
          <span class="menuitem-text" slot="title">体检项目分类</span>
        </el-menu-item>

        <el-menu-item index="admin_system_wx-user-list" @click.native="clkItem('/admin/system/wx-user-list')">
          <i class="menuitem-icon iconfont icon-fenlei"></i>
          <span class="menuitem-text" slot="title">微信用户列表</span>
        </el-menu-item>

        <el-menu-item index="admin_system_case-list" @click.native="clkItem('/admin/system/case-list')">
          <i class="menuitem-icon iconfont icon-fenlei"></i>
          <span class="menuitem-text" slot="title">病例查询</span>
        </el-menu-item>



      </el-submenu>

    </el-menu>

  </div>
</template>

<script>
  import cssParam from '@/assets/styles/param.scss';

  export default {
    name: 'LeftMenu',
    computed: {
      cssParam1() {
        return cssParam;
      },
      leftMenuStatus1() {
        return this.$store.state.leftMenuStatus === 'close';
      },
      routeMenuIndex() {
        if (this.$route.meta == null || this.$route.meta.leftMenuIndex == null) {
          return 'admin_index';
        }
        return this.$route.meta.leftMenuIndex;
      },
      loginUserInfo(){
        return this.$store.state.loginUserInfo;
      },
      isSystemManager(){

        if(this.loginUserInfo==null){
          return false;
        }
        if(!this.loginUserInfo.permissions){
          return false;
        }
        let arrPerms = this.loginUserInfo.permissions;
        return arrPerms.indexOf('system_manager')>=0;

      },
    },
    created() {
    },
    data() {
      return {};
    },
    methods: {
      clkItem(path) {
        this.$router.push(path);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/param.scss";

  .el-menu {
    border-right: none;
  }

  .menuitem-icon, .menuitem-text {
    transition: color 0.3s;
    -moz-transition: color 0.3s;

  }

  .menuitem-text{
    .hid-hotkey{
      opacity: 0;
      transition: opacity 0.3s;
    }
  }
  .menuitem-text:hover{
    .hid-hotkey{
      opacity: 1;
    }
  }

  .box-sidebar {
    -webkit-transition: width $transitionTime;
    transition: width $transitionTime;
    width: $leftMenuWidth !important;
    background-color: $bgLeftMenu;
    height: 100%;
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;

    .el-scrollbar {
      height: 100%;
      overflow: hidden;
    }


  }

  .el-scrollbar-leftmenu {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .el-menu-item, .el-submenu__title{
    height:46px;
    line-height: 45px;
  }
  .el-submenu .el-menu-item {
    height: 40px;
    line-height: 40px;
    padding: 0 35px;
    min-width: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/admin/LeftMenu.vue